import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from "@ngrx/effects";
import { Action } from "@ngrx/store";
import { observable, of, Observable } from "rxjs";
import { map, mergeMap, catchError, delay} from "rxjs/operators";

import { ClientService } from '@core/services/client/client.service';
import * as clientsActions from "../state/client.actions";
import { Client, ClientFileInfoModel } from '@core/services/client/client.model';


@Injectable()
export class ClientsEffect{
    constructor(
        private actions$: Actions,
        private clientService: ClientService
    ){}

     /* -Load  ALL Clients- */

     @Effect()
     loadClients$: Observable<Action> = this.actions$.pipe(
         ofType<clientsActions.LOADCLIENTS>(
            clientsActions.ClientActionTypes.LOAD_CLIENTS
         ),
       mergeMap((actions: clientsActions.LOADCLIENTS) =>
         this.clientService.getAllClients().pipe(
             map(
                 (clients: Client[])=>
                     new  clientsActions.LOADCLIENTSSUCCESS(clients)
                 ),
                 catchError(err => of(new clientsActions.LOADCLIENTSFAIL(err)))
             )
         )
         );

        /* -Load  one Client- */

        @Effect()
        loadClient$: Observable<Action> = this.actions$.pipe(
          ofType<clientsActions.LOADCLIENT>(
            clientsActions.ClientActionTypes.LOAD_CLIENT
          ),
          mergeMap((action: clientsActions.LOADCLIENT) =>
            this.clientService.retrieveClientById(action.payload).pipe(
              map(
                (client: Client) =>
                  new clientsActions.LOADCLIENTSUCCESS(client)
              ),
              catchError(err => of(new clientsActions.LOADCLIENTFAIL(err)))
            )
          )
        );


          /* -create Client- */

          @Effect()
          createClient$: Observable<Action> = this.actions$.pipe(
           ofType<clientsActions.CREATECLIENT>(
            clientsActions.ClientActionTypes.CREATE_CLIENT
           ),
           map((action: clientsActions.CREATECLIENT) => action.payload),
           mergeMap((client: Client) =>
                  this.clientService.createClient(client).pipe(
            map(
               (client: Client) =>
                new clientsActions.CREATECLIENTSUCCESS(client)
             ),
              catchError(err => of(new clientsActions.CREATECLIENTFAIL(err)))
        )
      )
    );

     /* -update Client- */

    @Effect()
    updateClient$: Observable<Action> = this.actions$.pipe(
      ofType<clientsActions.UPDATECLIENT>(
        clientsActions.ClientActionTypes.UPDATE_CLIENT
      ),
      map((action: clientsActions.UPDATECLIENT) => action.payload),
      mergeMap((client: Client) =>
        this.clientService.updateClient(client).pipe(
          map(
            (updateClient: Client) =>
              new clientsActions.UPDATECLIENTSUCCESS({
                id: updateClient.id,
                changes: updateClient
              })
          ),
          catchError(err => of(new clientsActions.UPDATECLIENTFAIL(err)))
        )
      )
    );
}
